import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PayrollSnackRewardItem } from '../../../services/payroll-snacks-assignment/payroll-snacks-assignment.service';

@Component({
    selector: 'app-snack-reward-preview',
    templateUrl: './snack-reward-preview.component.html',
    styleUrls: ['./snack-reward-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SnackRewardPreviewComponent {
  @Input() reward?: PayrollSnackRewardItem | null;

  private trustedHtmlCache = new Map<string, SafeHtml>();

  constructor(private domSanitizer: DomSanitizer) {}

  getBannerTitle(): string {
    return `${this.reward?.title || ''}`.trim();
  }

  getBannerSubtitleHtml(): SafeHtml {
    return this.getTrustedHtml(this.reward?.bannerSubtitleHtml || '');
  }

  getDetailHeaderHtml(): SafeHtml {
    return this.getTrustedHtml(this.reward?.detailHeaderHtml || '');
  }

  getDetailContentsHtml(): SafeHtml {
    return this.getTrustedHtml(this.reward?.detailContentsHtml || '');
  }

  getSnackCardStyles(): Record<string, string> {
    return {
      'background-color': this.reward?.backgroundColor || '#ffffff',
      color: this.reward?.textColor || '#000000',
      width: this.reward?.bannerWidth || '250px',
    };
  }

  getSnackCardInnerStyles(): Record<string, string> {
    return {
      'background-size': this.reward?.bannerBackgroundSize || 'auto',
      'background-image': this.reward?.bannerBackgroundImage || '',
      color: this.reward?.textColor || '#000000',
    };
  }

  hasDetailPreview(): boolean {
    return !!(this.reward?.detailHeaderHtml || this.reward?.detailContentsHtml);
  }

  private getTrustedHtml(value: string): SafeHtml {
    const html = `${value || ''}`;
    if (!this.trustedHtmlCache.has(html)) {
      this.trustedHtmlCache.set(html, this.domSanitizer.bypassSecurityTrustHtml(html));
    }
    return this.trustedHtmlCache.get(html) as SafeHtml;
  }
}
